<template>
  <div class="row cookie-box">
    <div class="center">
      <div class="col-xs-8">
        <div class="cookie-badge">
          <div class="name">
            {{ fullName | anonymize }}
          </div>
          <div class="cookie-badge-location">
            {{ city }}, {{ state }} {{ zip }}
          </div>
        </div>
      </div>
      <div class="col-xs-4 cookie-badge-not-you-wrapper">
        <button
          class="cookie-badge-not-you-button"
          type="button"
          @click.prevent="resetCookie"
        >
          {{ $t("message.ResetCookie") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "CookieBadge",
  props: {
    city: {
      required: true,
      type: String
    },
    firstname: {
      required: true,
      type: String
    },
    lastname: {
      required: true,
      type: String
    },
    state: {
      required: true,
      type: String
    },
    zip: {
      required: true,
      type: String
    }
  },
  computed: {
    fullName() {
      return `${this.firstname} ${this.lastname}`;
    }
  },
  methods: {
    resetCookie() {
      const currentLocation = window.location.href;
      window.location.assign(`${currentLocation}&resetcookie=1`);
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.cookie-box {
  margin: 10px 0 10px 0;

  .center {
    border: 1px solid #676e72;
    box-sizing: border-box;
    display: flex;
    margin: 0 auto;
    padding: 5px;
    width: 350px;

    .name {
      font-size: 1.3em;
    }

    .cookie-badge-location {
      font-size: 0.8em;
    }

    .cookie-badge-not-you-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      .cookie-badge-not-you-button {
        background-color: #fff9f1;
        border: 3px solid #ffa43c;
        border-radius: 10px;
        color: #925630;
        display: flex;
        font-size: 0.7em;
        font-weight: bold;
        line-height: 15px;
        text-align: center;
        padding: 3px 10px 3px 10px;
        text-align: center;
      }
    }
  }
}
</style>
